import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setMemberTypeProperties } from "../../stores/customForm/customFormActions";
import MemberTypePropertiesList from "./MemberTypePropertiesList";

const CustomFormSidebar = ({ member_type_properties }) => {
  const dispatch = useDispatch();
  const visibleMemberTypeProperties = useSelector(
    (state) => state.customForm.visible_member_type_properties
  );

  useEffect(() => {
    dispatch(setMemberTypeProperties(member_type_properties));
  }, [member_type_properties, dispatch]);

  return (
    <MemberTypePropertiesList
      member_type_properties={visibleMemberTypeProperties}
    />
  );
};

export default CustomFormSidebar;
